import { PayChargePopupRepository } from "../domain/PayChargePopupRepository";
import { PayChargePopupScreenData } from "../domain/PayChargePopupScreenData";
import { FileRepository } from "../../shared/domain/FileRepository";

export class PayChargePopupAllCommands {
    screen_data: PayChargePopupScreenData;
    repo: PayChargePopupRepository;
    file_repo: FileRepository;

    constructor(screen_data: PayChargePopupScreenData, repo: PayChargePopupRepository, file_repo: FileRepository) {
        this.screen_data = screen_data;
        this.repo = repo;
        this.file_repo = file_repo;
    }

    changeView(view: string) {
        switch (view) {
            case "payment_details":
                this.screen_data.title = "Pagar cargo";
                break;
            case "payment_method":
                this.screen_data.title = "Método de pago";
                break;
            case "loading":
                this.screen_data.title = "Cargando...";
                break;
            case "success":
                this.screen_data.title = "Pago exitoso";
                break;
            case "fail":
                this.screen_data.title = "Pago fallido";
                break;
        }
        this.screen_data.view = view;
    }

    next() {
        this.changeView('payment_method');
    }

    async getUserTax() {
        const result = await this.repo.getUserTax({});
        this.screen_data.tax_imposed = result.tax_imposed;
        this.screen_data.tax_name = result.tax_name;
        this.screen_data.tax = result.tax;
    }

    calculateToPay(): string {
        let total_amount = 0;
        if (this.screen_data.tax_imposed && this.screen_data.tax_imposed > 0) {
            total_amount = this.screen_data.selected_charge_for_pay_charge_popup.charge_amount * ((this.screen_data.tax_imposed / 100) + 1);
        } else {
            total_amount = this.screen_data.selected_charge_for_pay_charge_popup.charge_amount;
        }
        return total_amount.toFixed(2);
    }

    changePaymentMethod(payment_method: string) {
        this.screen_data.payment_method = payment_method;
    }

    changeFile() {
        if (this.screen_data.payment_file instanceof File && this.screen_data.payment_file.type !== 'application/pdf') {
            this.screen_data.payment_file = null;
            this.screen_data.file_input_key++;
            this.screen_data.file_input_error = true;
            return;
        } else {
            this.screen_data.file_input_error = false;
        }
    }

    isDisabledPayWithTransfer(): boolean {
        return !this.screen_data.payment_file;
    }

    async rememberUsedCard() {
        const response = await this.repo.rememberUsedCard({});
        if (!response) {
            return;
        }
        this.screen_data.used_card.stripe_customer_id = response.card_data.stripe_customer_id;
        this.screen_data.used_card.payment_method_id = response.card_data.payment_method_id;
        this.screen_data.used_card.last4 = response.card_data.last4;
        this.screen_data.used_card.use_old_card = response.card_data.use_old_card;
    }

    async payWithTransfer(forceRefreshUserData?: () => Promise<void>) {
        this.changeView("loading");
        const payment_file_path = await this.file_repo.uploadFile(this.screen_data.payment_file);
        const args = {
            charge_id: this.screen_data.selected_charge_for_pay_charge_popup.charge_id,
            payment_file_path: payment_file_path,
        };
        const response = await this.repo.payByTransfer(args);

        if (response && response.output) {
            this.screen_data.error_message = response.output.message;
            this.changeView(response.output.success ? 'success' : 'fail');
            if (response.output.success && forceRefreshUserData) {
                await forceRefreshUserData();
            }
        }
    }

    payWithCard() {
        if (this.screen_data.used_card.use_old_card) {
            return this.payWithOldCard();
        } else {
            return this.payWithNewCard();
        }
    }

    async payWithOldCard() {
        this.changeView("loading");
        const args = {
            charge_id: this.screen_data.selected_charge_for_pay_charge_popup.charge_id,
            stripe_customer_id: this.screen_data.used_card.stripe_customer_id,
            payment_method_id: this.screen_data.used_card.payment_method_id,
        };
        const response = await this.repo.payWithOldCard(args);
        const view = response.output.status == 'ok' ? 'success' : 'fail';
        this.changeView(view);
    }

    async payWithNewCard() {
        const args = {
            charge_id: this.screen_data.selected_charge_for_pay_charge_popup.charge_id,
            stripe_customer_id: this.screen_data.used_card.stripe_customer_id,
        };
        const response = await this.repo.payWithNewCard(args);
        window.open(response.output.url, '_blank', 'width=388, height=689');
        this.changeView("loading");
    }

    createListener() {
        this.screen_data.message_listener = (event) => {
            if (event.data.stripe_result) {
                const view = event.data.stripe_result == "ok" ? "success" : "fail";
                this.changeView(view);
            }
        };
        window.addEventListener('message', this.screen_data.message_listener);
    }

    async run(selected_charge_for_pay_charge_popup: any) {
        this.screen_data.selected_charge_for_pay_charge_popup = selected_charge_for_pay_charge_popup;
        await this.getUserTax();
        await this.rememberUsedCard();
        this.createListener();
        this.changeView("payment_details");
    }
}
